import {IReduxChatsState} from '@src/@interfaces';

export const state: IReduxChatsState = {
    activeChatUUID: null,
    loaded: false,
    loading: false,
    error: null,
    filter: {
        query: null,
    },
    users: [],
    channels: [],
    chats: [],
};
